import { FC, useEffect } from 'react'
import { Listing, User } from 'graphql/types'
import * as events from 'pages/recomendacoes/events'
import Toast from 'components/Toast'
import EmptyProfile from '../../EmptyProfile'
import EmptyRecommendations from '../../EmptyRecommendations'
import Carousel from '../../Carousel'
import styles from './RecommendationsTab.module.scss'
import Loader from 'components/Loader'

export type TTabsName = 'recommendations' | 'favorites'

export type TProps = {
  userProfile?: User | null
  recommendations?: Array<Listing> | null
  openQEVModal: () => void
  isVisible: boolean
  isLoading: boolean
}

const RecommendationsTab: FC<TProps> = ({
  userProfile,
  recommendations,
  openQEVModal,
  isVisible,
  isLoading,
}) => {
  const hasProfile = !!userProfile?.hasSearchPreferences
  const hasRecommendations = !!recommendations?.length
  const isEmptyProfileRecommendations = hasProfile && !hasRecommendations

  useEffect(() => {
    if (!isVisible) return

    events.recommendationsOpenEvent(hasProfile, recommendations?.length || 0)

    if (isEmptyProfileRecommendations) events.recommendationsOpenNotFoundEvent()
  }, [
    isEmptyProfileRecommendations,
    hasProfile,
    recommendations?.length,
    isVisible,
  ])

  if (isLoading) return <Loader />

  return (
    <>
      {!hasProfile && <EmptyProfile openQEVModal={openQEVModal} />}
      {isEmptyProfileRecommendations && (
        <EmptyRecommendations
          userProfile={userProfile}
          openQEVModal={openQEVModal}
        />
      )}
      {hasRecommendations && (
        <Carousel
          listings={recommendations}
          userProfile={userProfile}
          openQEVModal={openQEVModal}
          isVisible={isVisible}
          favoritesCarousel={false}
        />
      )}
      <Toast className={styles.ecRecommendationsTabToast} />
    </>
  )
}

export default RecommendationsTab
